<template>
  <div>
    <div>
      <el-table :data="tableData.aaData" border style="width: 100%" >
        <el-table-column align='center' prop="userName" label="姓名" :show-overflow-tooltip='true' tooltip-effect='light'>
        </el-table-column>
        <el-table-column align='center' prop="logonName" label="账号" :show-overflow-tooltip='true' tooltip-effect='light'>
        </el-table-column>
        <el-table-column align='center' prop="orgName" label="所属机构：" :show-overflow-tooltip='true' tooltip-effect='light'>
        </el-table-column>
        <el-table-column align='center' prop="ipAddress" label="IP地址" :show-overflow-tooltip='true' tooltip-effect='light'>
        </el-table-column>
        <el-table-column align='center' prop="platfromName" label="登录平台" :show-overflow-tooltip='true' tooltip-effect='light'>
        </el-table-column>
        <el-table-column align='center' prop="platfromNo" label="平台版本" :show-overflow-tooltip='true' tooltip-effect='light'>
        </el-table-column>
        <el-table-column align='center' prop="browser" label="浏览器" :show-overflow-tooltip='true' tooltip-effect='light'>
        </el-table-column>
        <el-table-column align='center' prop="loginDate" label="上线时间" :show-overflow-tooltip='true' tooltip-effect='light'>
          <template slot-scope="aa">
            <span>{{aa.row.loginDate | dateFormatYmdHms}}</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="logoutDate" label="下线时间" :show-overflow-tooltip='true' tooltip-effect='light'>
          <template slot-scope="aa">
            <span v-if="aa.row.logoutDate">
              {{aa.row.logoutDate | dateFormatYmdHms}}
            </span>
            <span label="下线时间" v-else>
              ——
            </span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="logoutDate" label="在线时长" :show-overflow-tooltip='true' tooltip-effect='light'>
          <template slot-scope="aa">
            <span v-if="aa.row.logoutDate && aa.row.loginDate">
              {{aa.row | getOnlineLength}}
            </span>
            <span v-else>
              ——
            </span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="loginDevice" label="登录设备" :show-overflow-tooltip='true' tooltip-effect='light'>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="aa">
            <span class="btnW" v-if="$store.state.permission['BASE-XXGL-XQ']">
              <el-button type="text" @click="showDetail(aa.row)">查看</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer_pagination" align="center">
        <el-pagination @current-change="handleCurrentChange" :current-page="tableQuery.page" :page-size="tableQuery.size" layout=" ->, total, prev, pager, next, jumper"
          :total="tableData.iTotalRecords">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="登录详情" v-if="isShow" :visible.sync="isShow" :close-on-click-modal="false">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="用户姓名：">
              {{userLog.userName}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="用户姓名：">
              {{userLog.logonName}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="上线时间：">
              {{userLog.loginDate | dateFormatYmdHms}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="下线时间：">
              <span v-if="userLog.logoutDate">
                {{userLog.logoutDate | dateFormatYmdHms}}
              </span>
              <span v-else>
                ——
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="在线时长：">
              <span v-if="userLog.logoutDate && userLog.loginDate">
                {{userLog | getOnlineLength}}
              </span>
              <span v-else>
                ——
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="所属机构：">
              {{userLog.orgName}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="IP地址：">
              {{userLog.ipAddress}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="登录平台：">
              {{userLog.platfromName}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="平台版本：">
              {{userLog.platfromNo}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="浏览器：">
              {{userLog.browser}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="登录设备：">
              {{userLog.loginDevice}}
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item label="浏览器版本：">
              {{userLog.copyright}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    components: {},
    filters: {
      getOnlineLength(obj) {
        let startTime = new Date(obj.loginDate);
        let ednDate = new Date(obj.logoutDate);
        let timeLength = ednDate.getTime() - startTime.getTime();
        //计算出相差天数
        var days = Math.floor(timeLength / (24 * 3600 * 1000));
        var dayStr = days > 0 ? days + "天" : "";
        //计算出小时数
        var hourMesc = timeLength % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
        var hours = Math.floor(hourMesc / (3600 * 1000));
        var hourStr = hours > 0 ? hours + "时" : "";
        //计算相差分钟数
        var minuteMesc = hourMesc % (3600 * 1000); //计算小时数后剩余的毫秒数
        var minutes = Math.floor(minuteMesc / (60 * 1000));
        var minuteStr = minutes > 0 ? minutes + "分" : "";
        //计算相差秒数
        var secondMesc = minuteMesc % (60 * 1000); //计算分钟数后剩余的毫秒数
        var seconds = Math.round(secondMesc / 1000);
        var secondStr = seconds > 0 ? seconds + "秒" : "";

        return dayStr.concat(hourStr, minuteStr, secondStr)
      },
      dateFormatYmdHms(date){
        if (date) {
          return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }

      }
    },
    data() {
      return {
        isShow: false,
        filter: {
          accountId: this.$store.state.userInfo.id
        },
        tableQuery: {
          page: 1,
          size: 10,
          draw: 0,
          order: "loginDate=desc",
        },
        tableData: {
          aaData: [],
          draw: 0,
          iTotalDisplayRecords: 0,
          iTotalRecords: 0
        },
        userLog: {}
      };
    },
    mounted() {
      this.query();
    },
    methods: {
      handleCurrentChange(val) {
        let vm = this;
        vm.tableQuery.page = val;
        vm.query();
      },
      showDetail(row) {
        let vm = this;
        vm.isShow = true;
        vm.userLog = row;
      },
      query() {
        let vm = this;
        vm.tableQuery.filter = eduFilterParam(vm.filter);
        http.get(InterfacePrefix['platform']+'/userlog', {
            params: vm.tableQuery
          })
          .then(function (xhr) {
            vm.tableData = xhr.data;
          });
      }
    }
  };
</script>
<style>
  .footer_pagination .el-pagination{ margin: 16px 0; }
</style>



// WEBPACK FOOTER //
// src/components/setting/basic_information/login_info.vue